import React from "react";
import Wrapper from "../components/wrapper/Wrapper";
import aboutbanner from "../images/about_page_banner.jpg";
import aboutBannerMob from "../images/about_page_banner_mobile.jpg";
import ourStoryImg from "../images/about_our_story.jpg";
import ourWorkImg from "../images/about_our_work.jpg";
import teamImg from "../images/about_team.jpg";
import team_member_4 from "../images/team_member_4.png";
import team_member_5 from "../images/team_member_5.png";
import team_member_6 from "../images/team_member_6.png";
import team_member_7 from "../images/team_member_7.png";



const teamMembers = [
  {
    memberIcon: team_member_4,
    name: "Sahil",
    designation: "Travel and Administration"
  },
  {
    memberIcon: team_member_4,
    name: "Aditya",
    designation: "Trekking Lead"
  },
  {
    memberIcon: team_member_4,
    name: "Shruti",
    designation: "City Guide"
  },
  {
    memberIcon: team_member_4,
    name: "Mingma Sherpa",
    designation: "Everest sumitter"
  },
  {
    memberIcon: team_member_5,
    name: "Angmo",
    designation: "Ladakh Cultural experiences"
  }, {
    memberIcon: team_member_6,
    name: "Thinless",
    designation: "Mountaineering Lead"
  }, {
    memberIcon: team_member_7,
    name: "Badri",
    designation: "Nepal Cultural Tours & Trekking Operations"
  },

];



const AboutPage = () => {

  return (
    <>
      <Wrapper
        desktopImage={aboutbanner}
        mobileImage={aboutBannerMob}
        firstTitle="here's a little"
        bannerHeading="About"
        bansubheading="First light Adventures"
        topfootHead="Get in touch!"
        topfootPara="Get in touch for any Himalayan travel insights—we’re here to help. Enjoy a free consultation call, whether you’re planning a trip or need advice on an itinerary. "
        bookCall="Book a Discovery Call"
      >

        <div className="container inner-container">
          <div className="row ourstory">
            <div className="col-md-6 col-lg-8">
              <h2> Our Story </h2>
              <p> We're an outcome of some incredible experiences in the Himalayas with some remarkable people over the years. This created a largely unplanned desire to share this with anyone willing to join us on our travels. We are a small but honest service thats bring you closer to the real Himalayas beyond just the places. </p>
              <div className="greentext">
                <span></span> the people of first light
              </div>
            </div>
            <div className="col-md-6 col-lg-4">
              <img src={ourStoryImg} alt="our_story" />
            </div>
          </div>


          <div className="ourwork">
            <img src={ourWorkImg} alt="our_work" />
            <h2> Our Work </h2>
            <p> Himalayan Travel experiences, that take everyone along. ie think of everyone and everything that makes travelling to the Himalayas possible and worth the while and add sincere respect to every exchange. This translates to providing our local teams with enough social and economic value to truly honour their effort; to offer our customers an authentic and unique and well researched experience at a price that is fair and worth their time investment and to be conscious about our footprint by literally minimising our footprint. </p>
          </div>
        </div>


        <div className="team">

          <div className="container inner-container">



            <div className="row">
              <div className="teaminfo col-md-6">
                {
                  teamMembers.map((member) =>
                    <div className="teammember" key={member.i}>
                      <div>
                        <img src={member.memberIcon} alt={member.name} />
                      </div>
                      <div>
                        <p className="title">{member.name}</p>
                        <p>{member.designation}</p>
                      </div>
                    </div>
                  )
                }
              </div>

              <div className="col-md-6">

                <div className="teamimg">
                  <img src={teamImg} alt="team" />
                </div>

                <div className="">

                  <div className="greentext">

                    <span></span> the people of first light
                  </div>
                  <h2>The Team</h2>
                  <p>We are a mix of travel, trekking and mountaineering specialists. Bringing different skills, experiences and interests. Our trips are led locally by some remarkable guides, and supported logistically through service partnerships formed through several years of operation.</p>
                </div>

              </div>
            </div>
          </div>
        </div>





      </Wrapper>
    </>
  );
};


export default AboutPage;




